export function buildPoints (points) {
    return {
        id: points.id,
        idFinesNotifierSubscription: points.id_fines_notifier_subscription,
        date: points.date,
        points: points.points,
    }
}
